import React from "react";
import "../styles/header.css";

const Header = ({ onLanguageChange, onHelpClick }) => {
	return (
		<div className="topbar">
			<div className="topbar-poweredby">Powered by © Fine Company</div>
			<div className="topbar-logos">
				<div className="logo"></div>
				<div className="second-logo"></div>
			</div>
			<div className="topbar-languages">
				<img
					alt="flag nl"
					className="flag-icon"
					onClick={() => onLanguageChange("nl")}
					src="images/nl.svg"
				/>
				<img
					alt="flag en"
					className="flag-icon"
					onClick={() => onLanguageChange("en")}
					src="images/gb.svg"
				/>
				<img
					alt="flag de"
					className="flag-icon"
					onClick={() => onLanguageChange("de")}
					src="images/de.svg"
				/>
				<img
					alt="flag fr"
					className="flag-icon"
					onClick={() => onLanguageChange("fr")}
					src="images/fr.svg"
				/>
				{false && <img
					alt="faq"
					src="images/question.svg"
					className="help-icon"
					onClick={() => onHelpClick()}
				/>}
			</div>
		</div>
	);
};

export default Header;
